import httpClient from './httpClient';

const td_status = () => httpClient.get('/api/td_status');
export {
    td_status
}